






















































import { Component, Mixins, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import MediaSelect from "@/components/MediaSelect.vue";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import AlertFeedList from "@/components/AlertFeedList.vue";
import AlertMixin from "@/mixins/http/Alert";
import { Alert } from "@/models";
import MediaValue from "@/interfaces/MediaValue";
import QueryHelper from "@/services/QueryHelper";
import QueryParser from "@/services/QueryParser";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";

const requestTag = "alertTypes";

Component.registerHooks(["beforeRouteUpdate"]);

interface AlertFeedFilter {
  type: string;
  alert: string;
  media: MediaValue;
}

const DEFAULT_FILTER: Readonly<AlertFeedFilter> = {
  media: { radio: true, tv: true },
  type: "alertLaunches",
  alert: "all",
};

@Component({
  components: {
    MediaSelect,
    MultiLevelSelect,
    AlertFeedList,
    PageGuide,
  },
})
export default class AlertFeed extends Mixins(AlertMixin) {
  @Getter("userMedia") readonly userMedia!: MediaValue;
  @Getter readonly parseAndCleanMediaValue!: (
    radio: string | boolean | undefined,
    tv: string | boolean | undefined
  ) => MediaValue;

  filter: AlertFeedFilter = { ...DEFAULT_FILTER };

  buildFilterFromQuery(): AlertFeedFilter {
    const query = this.$route.query;
    const { radio, tv } = query;

    const type = (query.type as string) || DEFAULT_FILTER.type;
    const alert = (query.alert as string) || DEFAULT_FILTER.alert;

    const media = this.parseAndCleanMediaValue(
      QueryParser.queryToBoolean(radio),
      QueryParser.queryToBoolean(tv)
    );
    return { type, alert, media };
  }

  @Watch("filter", { deep: true })
  onFilterChanged() {
    if (!QueryHelper.isSameQuery(this.$route.query, this.queryFilter)) {
      this.$router.replace({ query: { ...this.queryFilter } });
    }

    this.loadAlerts();
  }

  guidePath = GuidePaths.ALERT_FEED;

  get queryFilter() {
    const query = {
      type: this.filter.type,
      alert: this.filter.alert,
      tv: this.filter.media.tv ? "1" : "0",
      radio: this.filter.media.radio ? "1" : "0",
    };
    return query;
  }

  ready = false;

  triggerOptions: MultiLevelObject[] = [
    {
      id: "alertLaunches",
      text: "Partenza nuova campagna",
    },
  ];

  typeOptions: MultiLevelObject[] = [
    {
      id: "all",
      text: "Tutti i report",
    },
  ];

  created() {
    this.filter = { ...this.buildFilterFromQuery() };
  }

  async loadAlerts() {
    const alerts = await this.getAlerts(requestTag);
    const types = alerts.map((alert: Alert) => {
      return {
        id: alert.id,
        text: alert.name,
      };
    });

    this.typeOptions = [...this.typeOptions, ...types];
    this.ready = true;
  }
}
